import { } from "jquery"
import { inspect } from "util"
import { Asset, Tablet, QueryAsset, PagedListResult, Dict, QueryAssetOrderBy, AssetLoanHistory, ListResult, AssetLoan, LoanHistorySummary, CreateAssetLoanHistory, UpdateAssetLoan, ModelResult } from "../api/model"
import { AssetApi, AssetLoanApi, FileApi } from "../api/api"
import { UiUtils, JqElm, GeneralElementCreator } from "./ui"
import { AssetBasicDataProvider } from "./asset_page_base"
import { AssetSearchBlock, AssetSearchBlockBuilder, QueryResultCallback } from "./asset_search_block"
import { Pagination } from "../utils/pagination"
import { PaginationUi } from "./pagination_ui"
import { formatDate } from "../utils/date"
import { cleanProperties, copyProperties, sortByDate, convertToMultiMap, delay } from "../utils/core"
import { HouseKeeperHelper } from "./house_keeper_helper"
import { AssetLoanPageBase } from "./asset_loan_base"

export type SignatureStatus = "not_available" | "none" | "ok"


export class AssetReturnPage extends AssetLoanPageBase {
    private listTableElm: JqElm
    private loanHistorySummary: LoanHistorySummary
    loanHistoryItemCreator = new LoanHistoryItemElementCreator()
    returnItemCreator = new ReturnItemElementCreator()

    constructor(
        assetApi: AssetApi,
        assetLoanApi: AssetLoanApi,
        assetBasicDataProvider: AssetBasicDataProvider,
        fileApi: FileApi,
        houseKeeperHelper: HouseKeeperHelper
    ) {
        super(assetApi, assetLoanApi, houseKeeperHelper, fileApi, assetBasicDataProvider)

    }

    protected updateTablet(tablet: Tablet) {
        super.updateTablet.apply(this, arguments)
        this.queryLoanHistorySummary()
    }

    private toggleStep2Info(toggle: boolean) {
        $('#step2_info').toggle(toggle)
    }

    private async queryLoanHistorySummary(): Promise<LoanHistorySummary> {
        const result = await this.assetLoanApi.queryLoanHistorySummary({ tabletId: this.currentTablet.id, stillLoan: true }, this.assetApi)
        this.loanHistorySummary = result
        if (result.assets.length > 0) {
            cleanProperties(this.assetMap)
            result.assets.forEach(it => {
                this.assetMap[it.id] = it
            })
            this.toggleListElms(true)
            this.toggleStep2Info(true)
            this.fillLoanListData()
            this.gotoStep(2)
        } else {
            UiUtils.alert("此住戶沒有需要歸還的資產")
            this.toggleListElms(false)
            this.toggleStep2Info(false)
            this.gotoStep(1)
        }
        console.log("Result:%s", inspect(result))
        return result
    }

    private fillLoanListData() {
        $(`.${this.loanHistoryItemCreator.classId}`).remove()
        this.loanHistorySummary.loanHistories.forEach(hist => {
            const asset = this.loanHistorySummary.assets.find(it => it.id == hist.assetId)
            const elm = this.appendLoanItemElm(asset.id.toString(), hist.loanId)
            this.fillLoanElmData(asset, hist, elm)
        })
        UiUtils.setChecked($('[name=check_all]'), true).change()
    }

    private appendLoanItemElm(assetId: string, loanId: string): JqElm {
        const templateData = {
            id: `${loanId}_${assetId}`,
            assetId: assetId,
            loanId: loanId
        }
        const elm = this.loanHistoryItemCreator.createJqElm(templateData)
        elm.appendTo($(this.loanHistoryItemCreator.tmplElmId).parent())
        return elm
    }

    private appendReturnItemElm(assetId: string, loanId: string): JqElm {
        const templateData = {
            id: `${loanId}_${assetId}`,
            assetId: assetId,
            loanId: loanId
        }
        const elm = this.returnItemCreator.createJqElm(templateData)
        elm.appendTo($(this.returnItemCreator.tmplElmId).parent())
        return elm
    }

    listenProcessReturnClick() {
        $('#create_return_btn').click(e => {
            e.preventDefault()
            //this.takePictures()
            this.processReturn()
        })
    }

    private takePictures() {
        //console.log("Do take pic:%s", this.webCamStatus)
        const Webcam = (<any>window).Webcam
        Webcam.set({
            width: 230,
            height: 150,
            dest_width: 230,
            dest_height: 150,
            image_format: 'jpeg',
            jpeg_quality: 90,
            fps: 45
        });
        const that = this

        if (that.lockPictureButton == false) {
            $("#manualPicture").button("loading");
            that.lockPictureButton = true;
        }
        else {
            return;
        }

        if (this.webCamStatus) {
            Webcam.snap(function (dataUri: string) {
                $("#imgCapture").attr("alt", "上傳中...").attr("src", "");
                (<any>that.uploadTask).getTask("webcam").upload(dataUri).then(function (snapshot: object) {
                    //上傳成功 setTimeout防止連續拍照(firebase不允許短時間內多次上傳)
                    setTimeout(function () {
                        $("#imgCapture").attr("src", dataUri).attr("alt", "");
                        $("#theEnd").show();
                        $("#manualPicture").button("reset");
                        that.lockPictureButton = false;
                    }, 500);
                }).catch(function () {
                    //上傳失敗 setTimeout防止連續拍照(firebase不允許短時間內多次上傳)
                    setTimeout(function () {
                        $("#imgCapture").attr('src', '').attr("alt", "上傳失敗，請嘗試重新拍照");
                        $("#manualPicture").button("reset");
                        that.lockPictureButton = false;
                    }, 500);
                });
            })
        }
        else {
            //console.log("No pc")
            $(".webcamPhotoDiv .loading").hide()
            $("#theEnd").show()
        }
    }

    private async doReturnWithRetry(loanId: string, updateAssetLoan: UpdateAssetLoan, currentRetry: number = 0): Promise<ModelResult<AssetLoan>> {
        try {
            return await this.assetLoanApi.update(loanId, updateAssetLoan)
        } catch (e) {
            if (currentRetry < 2) {
                await delay(200)
                return await this.doReturnWithRetry(loanId, updateAssetLoan, currentRetry + 1)
            } else {
                throw e
            }
        }
    }

    private async processReturn(): Promise<void> {

        var fileName: string;
        var webcamUri: string;
        var handwriteUri: string;
        var uploadSuccess = false;

        await (<any>this.uploadTask).done().then(function (result: any) {
            fileName = result["fileName"];
            webcamUri = result["uri"]["webcam"];
            handwriteUri = result["uri"]["handwrite"];
            uploadSuccess = true;
        }).catch(function (status: string) {
            if (status != "cancel")
            {
                bootbox.alert("執行失敗，請洽技術中心");
            }
            uploadSuccess = false;
        });

        if(!uploadSuccess)
        {
            return;
        }

        const selector = `.${this.loanHistoryItemCreator.classId} [name=check]:checked`
        const selectedElms = $(`.${this.loanHistoryItemCreator.classId} [name=check]:checked`)
            .parents(`.${this.loanHistoryItemCreator.classId}`)
            .toArray()
            .map($)
        const assetIdsToQuery: Array<number> = []
        const historiesToReq: Array<CreateAssetLoanHistory> = selectedElms
            .map(elm => {
                const assetId = <number>elm.data('asset-id')
                if (assetIdsToQuery.indexOf(assetId) == -1) {
                    assetIdsToQuery.push(assetId)
                }
                const loanId = elm.data('loan-id')
                const q = <number>elm.find('[name=quantity]').val()
                return {
                    loanId: loanId,
                    assetId: assetId,
                    quantity: q,
                    signature: handwriteUri != null ? fileName : null,
                    picture: webcamUri != null ? fileName : null,
                }
            })
        const loanMapToReq: Dict<Array<CreateAssetLoanHistory>> = convertToMultiMap(historiesToReq, 'loanId')
        const requests = Object.keys(loanMapToReq).map(loanId => {
            const histories = loanMapToReq[loanId]
            return this.doReturnWithRetry(loanId, { returnHistories: histories, fileName : fileName, webcamUri: webcamUri, handwriteUri: handwriteUri })
        })
        try {
            const loanResps = (await Promise.all(requests)).map(it => it.data)
            const assets = (await this.assetApi.query({ ids: assetIdsToQuery, maxCount: 100 })).data

            $(`.${this.returnItemCreator.classId}`).remove()

            const sortedReturnHistories: Array<AssetLoanHistory> = sortByDate(loanResps[0].returnHistories, 'createdAt', true)
            const createdAt = sortedReturnHistories[0].createdAt
            const histories: Array<AssetLoanHistory> = historiesToReq.map(histReq => {
                return {
                    assetId: histReq.assetId,
                    loanId: histReq.loanId,
                    quantity: histReq.quantity,
                    createdAt: this.loanHistorySummary.loanHistories.find(it => it.assetId == histReq.assetId && it.loanId == histReq.loanId).createdAt
                }
            })

            histories.forEach(history => {
                const asset = assets.find(it => it.id == history.assetId)
                const rtElm = this.appendReturnItemElm(asset.id.toString(), history.loanId)
                this.fillReturnElmData(asset, history, rtElm)
            })
            this.toggleFinalElms(true)
            $('.date_success').text(formatDate(createdAt))
            this.gotoStep(3)
            this.resetStep2()
        } catch (e) {
            await UiUtils.alert("歸還失敗，重新載入欲歸還資產清單，請重新操作")
            this.updateTablet(this.currentTablet)
        }
    }

    private resetStep2() {
        this.loanHistorySummary = null
        $(`.${this.loanHistoryItemCreator.classId}`).remove()
        this.toggleStep2Info(false)
        this.toggleListElms(false)
        if (this.signatureStatus == 'ok') {
            this.processSignatureResult('')
        }
        this.toggleGotoStep3(false)
        //$("#imgCapture").attr('src', '')
        //$("#webcamPhoto").hide()
    }

    private fillReturnElmData(asset: Asset, history: AssetLoanHistory, assetElm: JqElm) {
        const id = assetElm.data('id')
        this.elmById(id, 'item_createdAt').text(formatDate(history.createdAt))
        this.elmById(id, 'item_displayId').text(asset.displayId)
        this.elmById(id, "item_name").text(asset.name)
        this.elmById(id, "item_created_at").text(formatDate(history.createdAt))
        this.elmById(id, 'item_quantity').text(history.quantity)
        this.elmById(id, 'item_communityAssignId').text(asset.communityAssignId != null ? asset.communityAssignId : '')
        const catName = this.assetBasicDataProvider.getCategoryName(asset.categoryId)
        this.elmById(id, 'item_category').text(catName)
        this.elmById(id, "item_area").text(this.assetBasicDataProvider.getAreaName(asset.areaId))
        this.elmById(id, "item_status").text(this.statusNameMap[asset.status])
        if (asset.type == 'fixed') {
            this.elmById(id, 'item_type').text('固定資產')
        } else {
            this.elmById(id, 'item_type').text('一般資產')
            if (asset.facilityIds != null && asset.facilityIds.length != 0) {
                this.elmById(id, 'item_facilityEnable').show()
                const facilityIds = new Set(asset.facilityIds)
                const facilityNames = this.assetBasicDataProvider.facilities.filter(it => facilityIds.has(it.id)).map(it => it.name)
                this.elmById(id, 'item_facilities').text(facilityNames.join(","))
            } else {
                this.elmById(id, 'item_facilityEnable').hide()
                this.elmById(id, 'item_facilities').text('')
            }
        }
        this.elmById(id, 'item_guestLoanable').toggle(asset.guestLoanable)
    }

    private fillLoanElmData(asset: Asset, history: AssetLoanHistory, assetElm: JqElm) {
        const id = assetElm.data('id')
        this.elmById(id, 'item_displayId').text(asset.displayId)
        this.elmById(id, "item_name").text(asset.name)
        this.elmById(id, "item_created_at").text(formatDate(history.createdAt))
        const quantityElm = this.elmById(id, null, 'quantity')
        for (let i = 1; i <= history.quantity; i++) {
            const iName = i.toString()
            quantityElm.append(UiUtils.options(iName, iName))
        }
        quantityElm.val(history.quantity)
        this.elmById(id, 'item_communityAssignId').text(asset.communityAssignId != null ? asset.communityAssignId : '')
        const catName = this.assetBasicDataProvider.getCategoryName(asset.categoryId)
        this.elmById(id, 'item_category').text(catName)
        this.elmById(id, "item_area").text(this.assetBasicDataProvider.getAreaName(asset.areaId))
        this.elmById(id, "item_status").text(this.statusNameMap[asset.status])
        if (asset.type == 'fixed') {
            this.elmById(id, 'item_type').text('固定資產')
        } else {
            this.elmById(id, 'item_type').text('一般資產')
            if (asset.facilityIds != null && asset.facilityIds.length != 0) {
                this.elmById(id, 'item_facilityEnable').show()
                const facilityIds = new Set(asset.facilityIds)
                const facilityNames = this.assetBasicDataProvider.facilities.filter(it => facilityIds.has(it.id)).map(it => it.name)
                this.elmById(id, 'item_facilities').text(facilityNames.join(","))
            } else {
                this.elmById(id, 'item_facilityEnable').hide()
                this.elmById(id, 'item_facilities').text('')
            }
        }
        this.elmById(id, 'item_guestLoanable').toggle(asset.guestLoanable)

    }

    toggleGotoStep3(toggle: boolean) {
        this.gotoStep3Elm.toggle(toggle)
    }

    toggleListElms(show: boolean) {
        this.listTableElm.toggle(show)
    }

    initUiElements() {
        super.initUiElements()
        this.listTableElm = $('#asset_mgt_list_table')
    }

    initNoteModal() {
        const page = this
        const modal = $('#note_ro_modal')
        const noteArea = $('#note_ro')
        modal.on('show.bs.modal', function (event) {
            const button = $(event.relatedTarget)
            const recordId = button.data('asset-id')
            modal.data('id', recordId)
            const asset = page.assetMap[recordId]
            const note = asset.note ? asset.note.replace(/(?:\r\n|\r|\n)/g, '<br />') : ''
            noteArea.html(note)
        })
    }

    listenCheckAllClick() {
        $('[name=check_all]').change(e => {
            const checked = UiUtils.isChecked($(e.currentTarget))
            UiUtils.setChecked($('[name=check]'), checked).change()
        })
    }

    canEnableStep3() {
        const selector = `.${this.loanHistoryItemCreator.classId} [name=check]:checked`
        return this.signatureStatus != 'none' && $(selector).length > 0
    }

    listenLoanCheck() {
        const selector = `.${this.loanHistoryItemCreator.classId} [name=check]`
        $(document).on('change', selector, e => {
            this.toggleGotoStep3(this.canEnableStep3())
        })
    }

    protected processSignatureResult(signUrl: string) {
        super.processSignatureResult(signUrl)
        this.toggleGotoStep3(this.canEnableStep3())
    }

}


export class LoanHistoryItemElementCreator extends GeneralElementCreator {
    classId: string = 'loan_item'
}
export class ReturnItemElementCreator extends GeneralElementCreator {
    classId: string = 'return_item'
}